export default __webpack_public_path__ + "static/media/prize_1pcs_mfc_rice_set.cc77c2b7.png";